import { render, staticRenderFns } from "./WineFilters.vue?vue&type=template&id=5e176812&scoped=true"
import script from "./WineFilters.vue?vue&type=script&lang=js"
export * from "./WineFilters.vue?vue&type=script&lang=js"
import style0 from "./WineFilters.vue?vue&type=style&index=0&id=5e176812&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e176812",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e176812')) {
      api.createRecord('5e176812', component.options)
    } else {
      api.reload('5e176812', component.options)
    }
    module.hot.accept("./WineFilters.vue?vue&type=template&id=5e176812&scoped=true", function () {
      api.rerender('5e176812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/WineFilters.vue"
export default component.exports